<script lang="ts" setup>
import { getColorValue } from '@global-types/colors';

withDefaults(defineProps<{
  size?: number
}>(), {
  size: 20,
});
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 16a6 6 0 100-12 6 6 0 000 12z"
      :stroke="getColorValue('blue')"
      stroke-opacity=".1"
      stroke-width="2"
    />
    <path d="M17 10a7 7 0 00-7-7v2a5 5 0 015 5h2z" :fill="getColorValue('blue')">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 10 10"
        to="360 10 10"
        dur="1s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
</template>
